<template>

     <!-- <v-dialog v-model="dialogurunDetay" persistent width="400px">
            <v-card color="white">
            <v-card-title> <span class=" grey--text font-weight- subheading">
                            {{$t('Remaining-Monthly-Amount-of-Usage')}} </span></v-card-title>
<v-card-text>
   
    <v-container class="bg-surface-variant"> 
    <v-layout row wrap> 
   
     <v-divider></v-divider>
    <div><strong>Bilet Adet:</strong> <div class="text-right">{{ this.BiletKontor2 }} </div>  </div><br>
    <div class="text-right w-100"><strong>Void Adet:</strong> <div> {{ this.VoidKontor2 }}</div> </div><br>
    <div><strong>İade Adet:</strong> <div>{{ this.IadeKontor2 }} </div></div><br>
    <div><strong>Coper Adet:</strong><div> {{ this.CoperKontor2 }}</div> </div><br>
    <div><strong>Coper İptal Adet:</strong><div>{{ this.CoperIptalKontor2 }} </div> </div><br>
    <div><strong>Vize Adet:</strong><div>{{ this.VizeKontor2 }} </div> </div><br>
    <div><strong>Cari Adet:</strong><div>{{ this.CariKontor2 }} </div> </div><br>
    <div><strong>Serbest Fatura Adet:</strong> <div>{{ this.FaturaKontor2 }} </div></div><br>
    <div><strong>Ek Kontör Sayısı:</strong><div>{{ this.EkKontorSayisi2 }} </div> </div><br>
    <v-divider></v-divider>
  
       
</v-layout>
<v-layout row wrap>
                                <span class=" red--text font-weight- caption"> &nbsp; {{$t('package-limits-need-to-buy')}}
                                     </span>
                            </v-layout>
</v-container>
       
         
           
           
            <div> <v-spacer></v-spacer>  <v-btn color="info" flat @click.native="dialogurunDetay=false">{{$t('Close')}}</v-btn></div>
</v-card-text>
           </v-card>
        
        </v-dialog> -->

        <v-dialog v-model="dialogurunDetay" scrollable="" max-width="400px">
                <v-card flat color="grey lighten-5">
                    <v-card-title> <span class=" grey--text font-weight- subheading">
                            {{$t('Remaining-Monthly-Amount-of-Usage')}} </span></v-card-title>
                    <v-divider></v-divider>
                    <v-card-text>

                        <v-layout row wrap>
                            <v-layout row wrap>
                                <v-flex xs12 sm12 md12>
                                    <v-list>
                                        <v-layout row wrap>
                                            <v-flex xs6 sm6 md6>
                                                <v-layout column="" align-start>
                                                    <v-card flat="">
                                                        <v-list-tile>
                                                            <v-list-tile-content>
                                                                <v-layout align-center>
                                                                    <v-flex>
                                                                        <v-list-tile-sub-title>
                                                                            <v-layout column align-center>
                                                                                <span class="font-weight-bold"> {{$t('Number-and-Type')}}</span> </v-layout>
                                                                        </v-list-tile-sub-title>
                                                                    </v-flex>
                                                                </v-layout>
                                                            </v-list-tile-content>
                                                        </v-list-tile>
                                                    </v-card>
                                                </v-layout>
                                            </v-flex>



                                            <v-flex xs6 sm6 md6>
                                                <v-layout column="" align-start>
                                                    <v-card flat="">
                                                        <v-list-tile>
                                                            <v-list-tile-content>
                                                                <v-layout align-center>
                                                                    <v-flex>
                                                                        <v-list-tile-sub-title>
                                                                            <v-layout column justiy-start align-center>
                                                                                <span class="font-weight-bold"> {{$t('Number')}}
                                                                                </span>
                                                                            </v-layout>
                                                                        </v-list-tile-sub-title>
                                                                    </v-flex>
                                                                </v-layout>
                                                            </v-list-tile-content>
                                                        </v-list-tile>
                                                    </v-card>
                                                </v-layout>
                                            </v-flex>

                                        </v-layout>
                                        <v-divider></v-divider>

                                        <v-layout row wrap>
                                            <v-flex xs6 sm6 md6>
                                                <v-layout align-start justify-start="">
                                                    <v-card flat="">
                                                        <v-list-tile>
                                                            <div class="font-weight-thin grey--text body-1">
                                                                {{$t('Number-of-Tickets')}}
                                                            </div>
                                                        </v-list-tile>
                                                    </v-card>
                                                </v-layout>
                                            </v-flex>
                                            <v-flex xs6 sm6 md6>
                                                <v-layout column="" align-start>
                                                    <v-card flat="">
                                                        <v-list-tile>
                                                            <v-list-tile-content>
                                                                <v-layout align-center>
                                                                    <v-flex>
                                                                        <v-list-tile-sub-title>
                                                                            <v-layout column justify-start=""
                                                                                align-start>
                                                                                :{{BiletKontor2}}
                                                                            </v-layout>
                                                                        </v-list-tile-sub-title>
                                                                    </v-flex>
                                                                </v-layout>
                                                            </v-list-tile-content>
                                                        </v-list-tile>
                                                    </v-card>
                                                </v-layout>
                                            </v-flex>
                                        </v-layout>
                                        <v-divider></v-divider>

                                        <v-layout row wrap>
                                            <v-flex xs6 sm6 md6>
                                                <v-layout align-start justify-start="">
                                                    <v-card flat="">
                                                        <v-list-tile>
                                                            <div class="font-weight-thin grey--text body-1">
                                                                {{$t('Number-of-Void')}}
                                                            </div>
                                                        </v-list-tile>
                                                    </v-card>
                                                </v-layout>
                                            </v-flex>
                                            <v-flex xs6 sm6 md6>
                                                <v-layout column="" align-start>
                                                    <v-card flat="">
                                                        <v-list-tile>
                                                            <v-list-tile-content>
                                                                <v-layout align-center>
                                                                    <v-flex>
                                                                        <v-list-tile-sub-title>
                                                                            <v-layout column justify-start=""
                                                                                align-start>
                                                                                :{{VoidKontor2}}
                                                                            </v-layout>
                                                                        </v-list-tile-sub-title>
                                                                    </v-flex>
                                                                </v-layout>
                                                            </v-list-tile-content>
                                                        </v-list-tile>
                                                    </v-card>
                                                </v-layout>
                                            </v-flex>
                                        </v-layout>
                                        <v-divider></v-divider>

                                        <v-layout row wrap>
                                            <v-flex xs6 sm6 md6>
                                                <v-layout align-start justify-start="">
                                                    <v-card flat="">
                                                        <v-list-tile>
                                                            <div class="font-weight-thin grey--text body-1">
                                                                {{$t('Number-of-Refunds')}}
                                                            </div>
                                                        </v-list-tile>
                                                    </v-card>
                                                </v-layout>
                                            </v-flex>
                                            <v-flex xs6 sm6 md6>
                                                <v-layout column="" align-start>
                                                    <v-card flat="">
                                                        <v-list-tile>
                                                            <v-list-tile-content>
                                                                <v-layout align-center>
                                                                    <v-flex>
                                                                        <v-list-tile-sub-title>
                                                                            <v-layout column justify-start=""
                                                                                align-start>
                                                                                :{{IadeKontor2}}
                                                                            </v-layout>
                                                                        </v-list-tile-sub-title>
                                                                    </v-flex>
                                                                </v-layout>
                                                            </v-list-tile-content>
                                                        </v-list-tile>
                                                    </v-card>
                                                </v-layout>
                                            </v-flex>
                                        </v-layout>
                                        <v-divider></v-divider>

                                        <v-layout row wrap>
                                            <v-flex xs6 sm6 md6>
                                                <v-layout align-start justify-start="">
                                                    <v-card flat="">
                                                        <v-list-tile>
                                                            <div class="font-weight-thin grey--text body-1">
                                                                {{$t('Number-of-Coper-PNRs')}}
                                                            </div>
                                                        </v-list-tile>
                                                    </v-card>
                                                </v-layout>
                                            </v-flex>
                                            <v-flex xs6 sm6 md6>
                                                <v-layout column="" align-start>
                                                    <v-card flat="">
                                                        <v-list-tile>
                                                            <v-list-tile-content>
                                                                <v-layout align-center>
                                                                    <v-flex>
                                                                        <v-list-tile-sub-title>
                                                                            <v-layout column justify-start=""
                                                                                align-start>
                                                                                :{{CoperKontor2}}
                                                                            </v-layout>
                                                                        </v-list-tile-sub-title>
                                                                    </v-flex>
                                                                </v-layout>
                                                            </v-list-tile-content>
                                                        </v-list-tile>
                                                    </v-card>
                                                </v-layout>
                                            </v-flex>
                                        </v-layout>
                                        <v-divider></v-divider>

                                        <v-layout row wrap>
                                            <v-flex xs6 sm6 md6>
                                                <v-layout align-start justify-start="">
                                                    <v-card flat="">
                                                        <v-list-tile>
                                                            <div class="font-weight-thin grey--text body-1">
                                                                {{$t('Number-of-Coper-PNRs-Cancelled')}}
                                                            </div>
                                                        </v-list-tile>
                                                    </v-card>
                                                </v-layout>
                                            </v-flex>
                                            <v-flex xs6 sm6 md6>
                                                <v-layout column="" align-start>
                                                    <v-card flat="">
                                                        <v-list-tile>
                                                            <v-list-tile-content>
                                                                <v-layout align-center>
                                                                    <v-flex>
                                                                        <v-list-tile-sub-title>
                                                                            <v-layout column justify-start=""
                                                                                align-start>
                                                                                :{{CoperIptalKontor2}}
                                                                            </v-layout>
                                                                        </v-list-tile-sub-title>
                                                                    </v-flex>
                                                                </v-layout>
                                                            </v-list-tile-content>
                                                        </v-list-tile>
                                                    </v-card>
                                                </v-layout>
                                            </v-flex>
                                        </v-layout>
                                        <v-divider></v-divider>

                                        <v-layout row wrap>
                                            <v-flex xs6 sm6 md6>
                                                <v-layout align-start justify-start="">
                                                    <v-card flat="">
                                                        <v-list-tile>
                                                            <div class="font-weight-thin grey--text body-1">
                                                                {{$t('Number-of-Visas')}}
                                                            </div>
                                                        </v-list-tile>
                                                    </v-card>
                                                </v-layout>
                                            </v-flex>
                                            <v-flex xs6 sm6 md6>
                                                <v-layout column="" align-start>
                                                    <v-card flat="">
                                                        <v-list-tile>
                                                            <v-list-tile-content>
                                                                <v-layout align-center>
                                                                    <v-flex>
                                                                        <v-list-tile-sub-title>
                                                                            <v-layout column justify-start=""
                                                                                align-start>
                                                                                :{{VizeKontor2}}
                                                                            </v-layout>
                                                                        </v-list-tile-sub-title>
                                                                    </v-flex>
                                                                </v-layout>
                                                            </v-list-tile-content>
                                                        </v-list-tile>
                                                    </v-card>
                                                </v-layout>
                                            </v-flex>
                                        </v-layout>
                                        <v-divider></v-divider>

                                        <v-layout row wrap>
                                            <v-flex xs6 sm6 md6>
                                                <v-layout align-start justify-start="">
                                                    <v-card flat="">
                                                        <v-list-tile>
                                                            <div class="font-weight-thin grey--text body-1">
                                                                {{$t('Current-Number')}}
                                                            </div>
                                                        </v-list-tile>
                                                    </v-card>
                                                </v-layout>
                                            </v-flex>
                                            <v-flex xs6 sm6 md6>
                                                <v-layout column="" align-start>
                                                    <v-card flat="">
                                                        <v-list-tile>
                                                            <v-list-tile-content>
                                                                <v-layout align-center>
                                                                    <v-flex>
                                                                        <v-list-tile-sub-title>
                                                                            <v-layout column justify-start=""
                                                                                align-start>
                                                                                :{{CariKontor2}}
                                                                            </v-layout>
                                                                        </v-list-tile-sub-title>
                                                                    </v-flex>
                                                                </v-layout>
                                                            </v-list-tile-content>
                                                        </v-list-tile>
                                                    </v-card>
                                                </v-layout>
                                            </v-flex>
                                        </v-layout>
                                        <v-divider></v-divider>

                                        <v-layout row wrap>
                                            <v-flex xs6 sm6 md6>
                                                <v-layout align-start justify-start="">
                                                    <v-card flat="">
                                                        <v-list-tile>
                                                            <div class="font-weight-thin grey--text body-1">
                                                                {{$t('Number-of-Free-Invoicing')}}
                                                            </div>
                                                        </v-list-tile>
                                                    </v-card>
                                                </v-layout>
                                            </v-flex>
                                            <v-flex xs6 sm6 md6>
                                                <v-layout column="" align-start>
                                                    <v-card flat="">
                                                        <v-list-tile>
                                                            <v-list-tile-content>
                                                                <v-layout align-center>
                                                                    <v-flex>
                                                                        <v-list-tile-sub-title>
                                                                            <v-layout column justify-start=""
                                                                                align-start>
                                                                                :{{FaturaKontor2}}
                                                                            </v-layout>
                                                                        </v-list-tile-sub-title>
                                                                    </v-flex>
                                                                </v-layout>
                                                            </v-list-tile-content>
                                                        </v-list-tile>
                                                    </v-card>
                                                </v-layout>
                                            </v-flex>
                                        </v-layout>
                                        <v-divider></v-divider>
                                        <v-layout row wrap>
                                            <v-flex xs6 sm6 md6>
                                                <v-layout align-start justify-start="">
                                                    <v-card flat="">
                                                        <v-list-tile>
                                                            <div class="font-weight-thin grey--text body-1">
                                                                {{$t('Nombre-de-crédits-additionels')}}
                                                            </div>
                                                        </v-list-tile>
                                                    </v-card>
                                                </v-layout>
                                            </v-flex>
                                            <v-flex xs6 sm6 md6>
                                                <v-layout column="" align-start>
                                                    <v-card flat="">
                                                        <v-list-tile>
                                                            <v-list-tile-content>
                                                                <v-layout align-center>
                                                                    <v-flex>
                                                                        <v-list-tile-sub-title>
                                                                            <v-layout column justify-start=""
                                                                                align-start>
                                                                                :{{EkKontorSayisi2}}
                                                                            </v-layout>
                                                                        </v-list-tile-sub-title>
                                                                    </v-flex>
                                                                </v-layout>
                                                            </v-list-tile-content>
                                                        </v-list-tile>
                                                    </v-card>
                                                </v-layout>
                                            </v-flex>
                                        </v-layout>
                                        <v-divider></v-divider>



                                    </v-list>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                                <span class=" red--text font-weight- caption"> &nbsp; {{$t('package-limits-need-to-buy')}}
                                     </span>
                            </v-layout>
                        </v-layout>

                    </v-card-text>

                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" flat @click.native="dialogurunDetay=false">{{$t('Close')}}</v-btn>

                    </v-card-actions>
                </v-card>
            </v-dialog>
</template>

<script>
  import auth from '../../../api/auth'
  import helpers from "@/components/app/customcomp/helpers.js"


  export default {
    props: ["value"],
    components: {
auth,
helpers
    },
    beforeMount: beforeMount,
    

    methods: {
     


      open() {
       
       

            var t = JSON.parse(window.localStorage.getItem('kontorBilgileri'));
            this.BiletKontor2=t.BiletKontor;
            this.CariKontor2=t.CariKontor;
            this.CoperIptalKontor2=t.CoperIptalKontor;
            this.CoperKontor2=t.CoperKontor;
            this.FaturaKontor2=t.FaturaKontor;
            this.IadeKontor2=t.IadeKontor;
            this.VizeKontor2=t.VizeKontor;
            this.VoidKontor2=t.VoidKontor;
            this.EkKontorSayisi2=t.EkKontorSayisi;
           
            
           
           this.dialogurunDetay = true;

      },
    },
    data() {
      return {
            BiletKontor2:0,
            CariKontor2:0,
            CoperIptalKontor2:0,
            CoperKontor2:0,
            FaturaKontor2:0,
            IadeKontor2:0,
            VizeKontor2:0,
            VoidKontor2:0,
            EkKontorSayisi2:0,
            dialogurunDetay:false
      }
    },


    watch: {

    },
  }




  function beforeMount() {

  }
</script>